import { equipmentAssetSeed } from './equipmentAssets';

/** Mutable unified equipment asset store (UI mock). */
let assets = equipmentAssetSeed.map((a) => ({ ...a, documents: [...(a.documents || [])] }));

export function getAssets() {
  return assets;
}

export function setAssets(next) {
  assets = next;
}

export function findAssetById(assetId) {
  return assets.find((a) => a.assetId === assetId) || null;
}

export function findAssetsByPeopleId(peopleId) {
  return assets.filter((a) => a.ownerType === 'Villager' && a.peopleId === peopleId);
}

export function findAssetsByVendorId(vendorId) {
  return assets.filter((a) => a.ownerType === 'Vendor' && a.vendorId === vendorId);
}

export function addAsset(asset) {
  assets = [...assets, asset];
  return asset;
}

export function updateAsset(assetId, patch) {
  assets = assets.map((a) =>
    a.assetId === assetId ? { ...a, ...patch, assetId: a.assetId } : a,
  );
  return findAssetById(assetId);
}

export function setAssetDocuments(assetId, documents) {
  return updateAsset(assetId, { documents: [...documents] });
}

export function addAssetDocument(assetId, doc) {
  const asset = findAssetById(assetId);
  if (!asset) return null;
  const documents = [...(asset.documents || []), doc];
  return updateAsset(assetId, { documents });
}

export function updateAssetDocument(assetId, docId, patch) {
  const asset = findAssetById(assetId);
  if (!asset) return null;
  const documents = (asset.documents || []).map((d) =>
    d.id === docId ? { ...d, ...patch, id: d.id } : d,
  );
  return updateAsset(assetId, { documents });
}

export function removeAssetDocument(assetId, docId) {
  const asset = findAssetById(assetId);
  if (!asset) return null;
  const documents = (asset.documents || []).filter((d) => d.id !== docId);
  return updateAsset(assetId, { documents });
}

export function nextDocumentId(assetId) {
  const asset = findAssetById(assetId);
  const count = asset?.documents?.length || 0;
  return `${assetId}-doc-${String(count + 1).padStart(2, '0')}-${Date.now().toString(36)}`;
}

export function nextAssetId() {
  const nums = assets
    .map((a) => {
      const m = String(a.assetId).match(/(\d+)$/);
      return m ? Number(m[1]) : 0;
    })
    .filter((n) => n > 0);
  const max = nums.length ? Math.max(...nums) : 0;
  return `AST-${String(max + 1).padStart(3, '0')}`;
}

/**
 * Free verified assets (not Deployed).
 * Match equipment type when provided; exclude requesting vendor's own fleet.
 */
export function findMatchingAssets({
  equipmentType = null,
  excludeVendorId = null,
  excludeAssetIds = [],
  limit = 50,
} = {}) {
  const type = String(equipmentType || '').trim().toLowerCase();
  const excluded = new Set(excludeAssetIds);
  return assets
    .filter((a) => {
      if (excluded.has(a.assetId)) return false;
      if (type && a.equipmentType.toLowerCase() !== type) return false;
      if (a.status !== 'Verified') return false;
      if (a.operationalStatus === 'Deployed') return false;
      if (excludeVendorId && a.ownerType === 'Vendor' && a.vendorId === excludeVendorId)
        return false;
      return true;
    })
    .slice(0, limit);
}
